import { css } from '@/styled-system/css';

export const propertyCardHomeDetailsStyles = css.raw({
  'display': 'inline',
  'listStyle': 'none',
  'margin': '0',
  'padding': '0',

  '& > li': {
    display: 'inline',
  },

  // 'content' uses empty alt text to ensure the pipe isn't announced by screen readers
  '& .c11n-home-details__pipe:after, &:not(:last-child):after': {
    content: '"|" / ""',
    color: 'text.subtle',
    marginInline: 'micro.default',
  },
});
